import NoProjects from 'components/shared/NoProjects/NoProjects'
import ProjectCard from 'components/shared/ProjectCard/ProjectCard'
import PropTypes from 'prop-types'
import { Container, Grid } from 'raspberry-pi-bits'

import './ProjectList.scss'

const LegacyProjectList = ({ display, projects, locale }) => {
  if (projects.length === 0) {
    return <NoProjects display={display} locale={locale} />
  }

  return (
    <Container
      className="test-projects-list"
      role="main"
      uMv="x3 x5@md x10@lg"
      id="skiptocontent"
    >
      <Grid equalHeight>
        {projects.map((project) => {
          return (
            <Grid.Column uSize="1/2@md 1/3@lg" uMb="x5" key={project.id}>
              <ProjectCard locale={locale} project={project} />
            </Grid.Column>
          )
        })}
      </Grid>
    </Container>
  )
}

LegacyProjectList.propTypes = {
  display: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  projects: PropTypes.array.isRequired,
}

export default LegacyProjectList
